//ionic
import {
  IonGrid,
  IonText,
  IonIcon,
  IonProgressBar,
  IonButton,
} from "@ionic/react";
import Rating from "components/aprendizaje/Rating";

//components

//icons
import { lockClosed, timeOutline } from "ionicons/icons";

//recoil
import { useRecoilValue } from "recoil";
import { userInfoState } from "recoil/User";

import "./singleModuleHeader.css";
import type { IExamInfo } from "services/interfaces/IExam";

interface IModule {
  module: {
    idModule: number;
    name: string;
    idBasis: number;
    createdAt: number;
    deletedAt: number | null;
    totalExercises: number;
    completedExercises: number;
    rating: string;
  };
  index: number;
  examInfo: IExamInfo | null | undefined;
  handleTestExam: () => void;
}

export const SingleModuleHeader: React.FC<IModule> = ({
  module,
  index,
  examInfo,
  handleTestExam,
}) => {
  const { totalExercises, completedExercises, name, rating } = module;
  const user = useRecoilValue(userInfoState);
  const { idSuscription } = user;

  const hasExamInfo =
    examInfo &&
    typeof examInfo === "object" &&
    Object.keys(examInfo).length > 0;

  const isModuleCompleted = completedExercises === totalExercises;

  // Deshabilitado si: módulo incompleto | aprobado | rechazado pero aún en cooldown.
  // Habilitado si: nunca realizó el examen | rechazado y ya pasaron examDaysBefore.
  const isExamDisabled = (() => {
    if (!isModuleCompleted) return true;
    if (!hasExamInfo) return false;
    const status = (examInfo.examStatus ?? examInfo.examResult ?? "")
      .toString()
      .toLowerCase();
    if (status === "approved" || status === "aprobado") return true;
    if (examInfo.examResultCreatedAt == null) return false; // Nunca lo realizó → puede tomarlo
    const lastExamMs =
      examInfo.examResultCreatedAt < 1e12
        ? examInfo.examResultCreatedAt * 1000
        : examInfo.examResultCreatedAt;
    const daysSinceLastExam = (Date.now() - lastExamMs) / (1000 * 60 * 60 * 24);
    const daysBefore = examInfo.examDaysBefore ?? 0;
    if (status === "rejected" || status === "rechazado") {
      return daysSinceLastExam < daysBefore; // Deshabilitado solo si no pasaron los días
    }
    return true; // Otro estado con fecha de resultado → deshabilitado
  })();

  const handleSubscription = () => {
    if (!idSuscription && module.idModule !== 10) {
      return (
        <IonText
          className="ba-circle-header h-ion-avatar ba-circle-text-module"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IonIcon icon={lockClosed} className="ba-lock-icon" />
        </IonText>
      );
    }

    return (
      <IonText
        className="ba-circle-header h-ion-avatar ba-circle-text-module"
        style={{ justifyContent: "center" }}
      >
        {completedExercises} de {totalExercises}
      </IonText>
    );
  };

  return (
    <IonGrid className="ba-single-module-container">
      <div
        className="flex"
        style={{ justifyContent: "space-between", alignItems: "end" }}
      >
        <div>
          {hasExamInfo ? (
            <IonButton
              shape="round"
              color="orange"
              className="rendir-examen-btn"
              disabled={isExamDisabled}
              onClick={handleTestExam}
            >
              Rendir examen de certificación
            </IonButton>
          ) : null}
          <Rating value={Number(rating)} />
          <IonText className="module-name-header">{name}</IonText>
          {/* <div className="flex" style={{ alignItems: 'center', marginTop: '5px' }}>
            <IonIcon style={{ color: 'white' }} icon={timeOutline} />
            <IonText className="f-time-header">3:11</IonText>
          </div> */}
        </div>

        <div className="progress-avatar-module" style={{ marginLeft: 2 }}>
          <IonProgressBar
            className="progress-bar"
            value={completedExercises / totalExercises}
          ></IonProgressBar>
          {handleSubscription()}
        </div>
      </div>
    </IonGrid>
  );
};
